import { SocialMedia } from 'constants/social-media'
import { Divider, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import GenomateLogo from 'components/genomateLogo/GenomateLogo'
import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import ContactAndButtonBlock from './ContactAndButtonBlock'
import {
    SOCIAL_ICON_DIMENSIONS,
    useStaticPageStyles,
    useStyles
} from './StaticpageWrapper.styles'

type StaticPageWrapperProps = {
    title?: string
    children: ReactNode
    isContentPage?: boolean
    withContact?: boolean
    withHomeButton?: boolean
    withLoginButton?: boolean
}

const StaticPageWrapper = ({
    children,
    title,
    withContact = false,
    isContentPage = false,
    withHomeButton = false,
    withLoginButton = false
}: StaticPageWrapperProps) => {
    const theme = useTheme()
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'))
    const styles = useStyles()
    const staticPageStyles = useStaticPageStyles()

    return (
        <Box className={styles.page}>
            <Box className={styles.container}>
                <Box className={styles.logoContainer}>
                    <Link to="/">
                        <GenomateLogo
                            fontSize={250}
                            width="32vh"
                            height="15vh"
                        />
                    </Link>
                </Box>
                <Box
                    className={`${styles.contentContainer}${
                        isContentPage
                            ? ` ${staticPageStyles.contentContainer}`
                            : ''
                    }`}
                >
                    {title && (
                        <Typography
                            className={styles.title}
                            variant={isLargeScreen ? 'h4' : 'h5'}
                            align="center"
                        >
                            {title}
                        </Typography>
                    )}
                    {children}

                    <ContactAndButtonBlock
                        styles={styles}
                        isLargeScreen={isLargeScreen}
                        withHomeButton={withHomeButton}
                        withLoginButton={withLoginButton}
                        withContact={withContact}
                    />
                </Box>
                <Box className={styles.footer}>
                    <Divider className={styles.divider} />
                    <Typography
                        variant={isLargeScreen ? 'body2' : 'caption'}
                        className={styles.address}
                    >
                        Genomate Health Inc - 1 Broadway, Cambridge, 02142, MA,
                        USA
                    </Typography>
                    <Box className={styles.socialMediaContainer}>
                        {SocialMedia.map(({ url, alt, href }) => (
                            <a
                                key={alt}
                                href={href}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={url}
                                    alt={alt}
                                    width={SOCIAL_ICON_DIMENSIONS}
                                    height={SOCIAL_ICON_DIMENSIONS}
                                />
                            </a>
                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default StaticPageWrapper
